export const EMAIL_ALLOWED_MAX_LENGTH = 55;
export const PHONE_ALLOWED_MAX_LENGTH = 50;
export const DEFAULT_ALLOWED_MAX_LENGTH = 255;
